(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/statistics/assets/javascripts/race-history-item.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/statistics/assets/javascripts/race-history-item.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  useContext,
  useState
} = React;
const {
  getRaceDiscipline,
  getKilometerTime
} = svs.racing.common.strings;
const {
  getCurrencyType
} = svs.racing.common.strings;
const {
  Link
} = ReactRouterDOM;
const {
  buildCouponLocation
} = svs.racing.navigation.location;
const {
  useNavigationState
} = svs.racing.navigation;
const {
  VODContext
} = svs.racing;
const {
  actions,
  PlayContext
} = svs.racing_game.components.playContext;
const Icon = svs.ui.ReactIcon;
const RaceHistoryExtended = svs.racing_game.components.statistics.RaceHistoryExtended;
const RaceHistoryItem = _ref => {
  let {
    race
  } = _ref;
  const {
    assetId,
    distance,
    raceDiscipline,
    participants,
    track,
    date,
    raceNumber,
    raceId,
    vodAvailableUntil
  } = race;
  const {
    setCurrentVOD
  } = useContext(VODContext);
  const {
    raceDispatch
  } = useContext(PlayContext);
  const [showFullInfo, setShowFullInfo] = useState(false);
  const currentParticipant = participants.filter(participant => participant.isCurrentParticipant)[0];
  const createLink = raceId && raceId > 0;
  const navState = useNavigationState();
  const firstParticipant = participants.filter(participant => participant.result.finishPlace === 1)[0];
  const currentFormattedDate = dateFns.format(new Date(date), 'yyMMdd', {
    locale: dateFns.locales.sv
  });
  const playVOD = function (assetId, currentFormattedDate, raceNumber) {
    let track = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    const vodObj = {
      assetId: assetId ? assetId : undefined,
      date: currentFormattedDate ? currentFormattedDate : '',
      track: track.trackName ? track.trackName : '',
      raceNumber: raceNumber ? raceNumber : ''
    };
    setCurrentVOD(vodObj);
  };
  const showVODButton = assetId => {
    if (svs.core.detect.feature('ft-racing-stream-player-solidtango') && assetId !== null && assetId !== void 0 && assetId.startsWith('Pmu_')) {
      return false;
    } else if (!svs.core.detect.feature('ft-racing-stream-player-solidtango') && !(assetId !== null && assetId !== void 0 && assetId.startsWith('Pmu_'))) {
      return false;
    }
    if (svs.core.detect.feature('ft-racing-vod') && dateFns.isBefore(new Date(date), new Date(2024, 0, 23))) {
      return false;
    }
    if (assetId && vodAvailableUntil) {
      return new Date(vodAvailableUntil).getTime() > Date.now();
    }
    return false;
  };

  if (!currentParticipant) {
    return null;
  }
  const vodColor = showFullInfo ? 'fc-white' : 'fc-grey-600';
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "race-history-row race-history-data ".concat(showFullInfo ? 'extended' : 'fc-navy')
  }, React.createElement("div", {
    className: "horse-history-column drop-down ".concat(showFullInfo ? 'fc-white' : 'fc-racing-900'),
    onClick: () => setShowFullInfo(!showFullInfo)
  }, React.createElement("i", {
    className: "icon icon-200 icon-menu-".concat(showFullInfo ? 'up' : 'down')
  })), React.createElement("div", {
    className: "horse-history-column horse-info"
  }, createLink ? React.createElement(Link, {
    onClick: () => {
      raceDispatch(actions.setRace(undefined));
    },
    to: buildCouponLocation(_objectSpread(_objectSpread({}, navState), {}, {
      day: dateFns.format(dateFns.parseISO(date), 'yyyy-MM-dd'),
      trackName: track.pathName,
      raceNumber,
      participantId: undefined,
      participantName: undefined,
      gameType: undefined
    }))
  }, React.createElement("div", {
    className: "race-date f-medium"
  }, currentFormattedDate)) : React.createElement("div", {
    className: "race-date f-medium"
  }, currentFormattedDate), React.createElement("div", {
    className: "track-name"
  }, track && track.trackName ? track.trackName : '-'), React.createElement("div", {
    className: "driver-name"
  }, currentParticipant.driverName)), React.createElement("div", {
    className: "horse-history-column vod-holder"
  }, showVODButton(assetId) ? React.createElement("div", {
    onClick: () => playVOD(assetId, currentFormattedDate, raceNumber, track)
  }, React.createElement(Icon, {
    color: vodColor,
    icon: "livestream",
    size: "200"
  })) : React.createElement("div", null, "-")), React.createElement("div", {
    className: "horse-history-column finish-place ".concat(currentParticipant.trotting ? 'trotting' : 'gallop')
  }, "\n              ".concat(currentParticipant.result.finishPlace || '-', "\n              ").concat(currentParticipant.gallop && currentParticipant.gallop.distancePrevious ? '-' : '', "\n              ").concat(currentParticipant.gallop && currentParticipant.gallop.distancePrevious || '', "\n            ")), React.createElement("div", {
    className: "horse-history-column race-distance"
  }, distance || '-'), React.createElement("div", {
    className: "horse-history-column race-dicipline"
  }, raceDiscipline ? getRaceDiscipline(raceDiscipline.toLowerCase()) : '-'), currentParticipant.gallop && React.createElement("div", {
    className: "horse-history-column start-gate"
  }, currentParticipant.gallop && currentParticipant.gallop.startGate && currentParticipant.gallop.startGate > 0 ? currentParticipant.gallop.startGate : '-'), currentParticipant.trotting ? React.createElement("div", {
    className: "horse-history-column kilometer-time"
  }, getKilometerTime(currentParticipant.trotting.kilometerTime)) : React.createElement("div", {
    className: "horse-history-column riders-weight"
  }, currentParticipant.gallop.driverTotalWeight), React.createElement("div", {
    className: "horse-history-column prize-money"
  }, firstParticipant && "".concat(svs.utils.format.Currency(firstParticipant.earnings), " ").concat(getCurrencyType(firstParticipant.currency)))), showFullInfo && React.createElement(RaceHistoryExtended, {
    isGallop: currentParticipant.gallop,
    isTrotting: currentParticipant.trotting,
    participants: participants
  }));
};
svs.racing_game.components.statistics.RaceHistoryItem = RaceHistoryItem;

 })(window);